
export function incrementCounter() {
    return {type: "INCREMENT"};
}

export function addTodo(title) {
    return {type: "TODO_ADD", title: title};
}

export function addEvent(comment) {
    return {type: "EVENT_ADD", comment: comment};
}

export function addNotice(comment) {
    return {type: "NOTICE_ADD", comment: comment};
}

export function addWebLink(webLink) {
    return {type: "WEBLINK_ADD", webLink: webLink};
}

export function removeWebLink(id) {
    return {type: "WEBLINK_REMOVE", id: id};
}

export function updateWebLink(webLink) {
    return {type: "WEBLINK_UPDATE", webLink: webLink};
}

export function  removeAllWebLinks(){
    return {type: "WEBLINK_REMOVE_ALL"};
}

export function addComment(comment) {
    return {type: "COMMENT_ADD", comment:comment};
}

export function removeComment(id) {
    return {type: "COMMENT_REMOVE", id: id};
}

export function updateComment(comment) {
    return {type: "COMMENT_UPDATE", comment: comment};
}

export function  removeAllComments(){
    return {type: "COMMENT_REMOVE_ALL"};
}


export function addInvited(user) {
    return {type: "INVITED_ADD", user: user};
}

export function removeInvited(user) {
    return {type: "INVITED_REMOVE", user: user};
}


export function addDateChoose(eventDate) {
    return {type: "EVENTDATE_ADD", eventDate: eventDate};
}

export function removeDateChoose(eventDate) {
    return {type: "EVENTDATE_REMOVE", eventDate: eventDate};
}

export function addUserComment(userComment) {
    return {type: "USERCOMMENT_ADD", userComment: userComment};
}

export function removeUserComment(id) {
    return {type: "USERCOMMENT_REMOVE", id: id};
}

export function updateUserComment(userComment) {
    return {type: "USERCOMMENT_UPDATE", userComment: userComment};
}

export function  removeAllUserComments(){
    return {type: "USERCOMMENT_REMOVE_ALL"};
}
